app.formsController = app.formsController || {};

app.formsController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        if($(".wpcf7-select").length) {
            this.transformSelect();
            this.transformFile();
            this.conditionalFiles();
        }
    },
    
    transformSelect : function () {
        $('.wpcf7-select').customSelect();
    },
    
    transformFile : function () {
        var $fileFld = $('.customFile');
        if ($fileFld.length > 0) {
            $fileFld.each(function() {
                var $file = $(this),
                    $fileName = $file.find('.fld-value'),
                    $fileInput = $file.find('input');
                $fileInput.on('change', function() {
                    $fileName.text($fileInput.val());
                });
            });
        }
    },
    
    conditionalFiles: function () {
        // Champ CV
        var $objectFld = $('#fld-objet');
        if ($objectFld.length > 0) {
            if ($objectFld.val() == 'Candidature spontanée' || $objectFld.val() == 'Demande de stage') {
                $('.cvFld').addClass('active');
            }
            else {
                $('.cvFld').removeClass('active').addClass('inactive');
            }
            $objectFld.on('change', function() {
                if ($objectFld.val() == 'Candidature spontanée' || $objectFld.val() == 'Demande de stage') {
                    $('.cvFld').addClass('active');
                }
                else {
                    $('.cvFld').removeClass('active').addClass('inactive');
                }
            });
        }
    }

};